import { useContext } from 'react';
import { ThemeContext } from '../store/ThemeContext.js';
import { SIDEBAR_WIDTH_CLASS } from '../config/navMenu';

export function useNavLayout() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useNavLayout must be used within a ThemeProvider');
  }

  const { navLayout = 'horizontal' } = context;
  const isHorizontal = navLayout === 'horizontal';

  return {
    navLayout,
    isHorizontal,
    isSidebar: !isHorizontal,
    contentLeftClass: isHorizontal ? 'md:left-0' : SIDEBAR_WIDTH_CLASS,
    contentTopClass: 'top-14'
  };
}
